import React, { useRef, useState, useCallback } from "react";
import { useEventListener, useWindowSize } from "usehooks-ts";
import { useIsFirstRender } from "usehooks-ts";

export const Fullpage = (props) => {
	const isFirst = useIsFirstRender();
	const { height } = useWindowSize();
	const ref = useRef(null);
	const [busy, setIsBusy] = useState(false);
	const busyTimer = useRef(null);

	const resetBusy = useCallback(() => {
		clearTimeout(busyTimer.current);
		setIsBusy(false);
	}, []);

	useEventListener(
		"wheel",
		(event) => {
			event.preventDefault();
			if (!busy) {
				let targetScroll = ref["current"]["scrollTop"];
				if (event.deltaY < 0) {
					targetScroll -= height;
					if (targetScroll < 0) {
						targetScroll = 0;
					}
				} else {
					targetScroll += height;
					if (targetScroll > ref["current"]["scrollHeight"]) {
						targetScroll = ref["current"]["scrollHeight"];
					}
				}
				if (targetScroll !== ref["current"]["scrollTop"]) {
					setIsBusy(true);
					ref["current"].scrollTo({ top: targetScroll });
					// Fallback for Safari < 16.4 which doesn't support scrollend.
					clearTimeout(busyTimer.current);
					busyTimer.current = setTimeout(resetBusy, 800);
				}
			}
		},
		ref
	);

	useEventListener("scrollend", resetBusy, ref);

	return (
		<div
			ref={ref}
			className='fullpage'
			style={{ height, scrollSnapType: isFirst ? "none" : "y mandatory" }}
			id='fullpage'>
			{props["children"]}
		</div>
	);
};
